require('./RAStrategyHistoryModal.scss');
// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');
const classnames = require('classnames');

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const { Portfolios } = require('../../utilities/RAPortfolioHelper');

//commons
const OKModal = require('components/commons/OKModal/OKModal');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKMessage } = require('commonsComponents/OKMessage');

const { RA_HISTORY_MODAL_ONE_PORTFOLIO } = require('../../raConstants/index');

class RAStrategyHistoryModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showFadedSection: true,
        };
        this.handleBuildScroll = this.handleBuildScroll.bind(this);
    }

    componentDidMount() {
        const { getPortfolioHistory, portfolioId } = this.props;
        getPortfolioHistory(portfolioId);
    }

    buildStrategyHistoryContent() {
        const { immAccountDetails } = this.props;
        const arrayOfPortfolioInfo = immAccountDetails.get('portfolioHistory');
        const mappedPortfolio = arrayOfPortfolioInfo.map(
            (portfolioInfo, index) => {
                const productId = portfolioInfo.get('newProductId');
                const className = `ra-strategy-history__portfolio-div-circle__value ra-strategy-history__portfolio-div-circle__value--${productId}`;
                const dateValue =
                    !!portfolioInfo.get('changeCompleted') &&
                    moment(portfolioInfo.get('changeCompleted')).format(
                        'DD MMM YYYY',
                    );
                const img =
                    Portfolios[productId] && Portfolios[productId].iconCircle;
                const portfolioName = portfolioInfo.get('newName');
                return (
                    <div
                        className={'ra-strategy-history__portfolio-div'}
                        key={index}
                    >
                        <div className="ra-strategy-history__portfolio-date-div">
                            <div className="ra-strategy-history__portfolio-date-div--value">
                                {dateValue}
                            </div>
                        </div>
                        <div className="ra-strategy-history__portfolio-div-circle">
                            <div className={className}></div>
                        </div>
                        <div className="ra-strategy-history__portfolio-div-line"></div>
                        <div className="ra-strategy-history__img-div">
                            <img
                                className="ra-strategy-history__img-div--value"
                                src={img}
                            />
                            <div className="ra-strategy-history__portfolio-name-div">
                                {portfolioName}
                            </div>
                        </div>
                    </div>
                );
            },
        );

        const historyDiv = (
            <div className="ra-strategy-history__portfolio-history-container">
                {mappedPortfolio}
            </div>
        );
        return historyDiv;
    }

    buildModelContent(historyApiError, buttonName, immPortfolio) {
        const { immAccountDetails } = this.props;
        const { showFadedSection } = this.state;
        const arrayOfPortfolioInfo = immAccountDetails.get('portfolioHistory')
            .size;
        const rowClassName = classnames({
            'ra-strategy-history__container': arrayOfPortfolioInfo > 2,
            'ra-strategy-history__small-container': arrayOfPortfolioInfo < 2,
        });
        const buildStrategyHistoryContent = this.buildStrategyHistoryContent();
        const typeOfProduct =
            immPortfolio && immPortfolio.getIn(['product', 'typeOfProduct']);
        const img = immPortfolio && Portfolios[typeOfProduct].iconCircle;
        const portfolioName =
            immPortfolio && Portfolios[typeOfProduct].portfolioName;
        let modalContent, fadedSection;

        if (
            showFadedSection &&
            arrayOfPortfolioInfo != RA_HISTORY_MODAL_ONE_PORTFOLIO
        ) {
            fadedSection = (
                <div className="ra-strategy-history__bottom-gradient-section"></div>
            );
        }

        if (!historyApiError) {
            if (arrayOfPortfolioInfo > 0) {
                const disclaimerClassName = classnames({
                    'ra-strategy-history__disclaimer':
                        arrayOfPortfolioInfo != RA_HISTORY_MODAL_ONE_PORTFOLIO,
                });
                modalContent = (
                    <div>
                        <div
                            className={rowClassName}
                            onScroll={this.handleBuildScroll}
                        >
                            <div className="ra-strategy-history__vertical-dashed-line">
                                <div className="ra-strategy-history__today-button">
                                    {buttonName}
                                </div>
                            </div>
                            {buildStrategyHistoryContent}
                        </div>
                        {fadedSection}
                        <div className={disclaimerClassName}>
                            <OKMessage type="informative">
                                <FormattedText value="rAStrategyHistoryModal-disclaimer" />
                            </OKMessage>
                        </div>
                    </div>
                );
            } else {
                //If Empty Response came from API show default portfolio as history
                const circleClassName = `ra-strategy-history__portfolio-div-circle__value ra-strategy-history__portfolio-div-circle__value--${typeOfProduct}`;
                modalContent = (
                    <div className="ra-strategy-history__empty-container">
                        <div className="ra-strategy-history__vertical-dashed-line">
                            <div className="ra-strategy-history__today-button">
                                {buttonName}
                            </div>
                        </div>
                        <div className="ra-strategy-history__portfolio-div ra-strategy-history__portfolio-div--empty-response">
                            <div className="ra-strategy-history__portfolio-div-circle">
                                <div className={circleClassName}></div>
                            </div>
                            <div className="ra-strategy-history__portfolio-div-line"></div>
                            <div className="ra-strategy-history__img-div">
                                <img
                                    className="ra-strategy-history__img-div--value"
                                    src={img}
                                />
                                <div className="ra-strategy-history__portfolio-name-div">
                                    {portfolioName}
                                </div>
                            </div>
                        </div>
                        <div className="ra-strategy-history__empty-container-msg">
                            <OKMessage type="informative">
                                <FormattedText value="rAStrategyHistoryModal-emptyStrategyMsg" />
                            </OKMessage>
                        </div>
                    </div>
                );
            }
        } else {
            modalContent = (
                <div className="ra-strategy-history__error-container ra-strategy-history__error-screen">
                    <EmptyState
                        primaryText={formatText(
                            'rAStrategyHistoryModal-errorMsg',
                        )}
                        iconType="nointernet-wealth"
                    />
                </div>
            );
        }
        return modalContent;
    }

    handleBuildScroll() {
        const documentContainer = document.getElementsByClassName(
            'ra-strategy-history__container',
        );
        const totalHeight = documentContainer[0].scrollHeight;
        const clientHeight = documentContainer[0].clientHeight;
        const scrollTop =
            documentContainer[0] && documentContainer[0].scrollTop
                ? documentContainer[0].scrollTop
                : documentContainer[0].scrollTop;
        if (totalHeight == parseInt(scrollTop + clientHeight)) {
            this.setState({
                showFadedSection: false,
            });
        }

        if (scrollTop == 0) {
            this.setState({
                showFadedSection: true,
            });
        }
    }

    render() {
        const {
            immAccountDetails,
            isModalOpen,
            immPortfolio,
            onModalClose,
        } = this.props;
        const historyApiError = immAccountDetails.get('isHistoryFetchingError');
        const buttonName = formatText('rAStrategyHistoryModal-date');
        const buildModelContent = this.buildModelContent(
            historyApiError,
            buttonName,
            immPortfolio,
        );
        const title = formatText('rAStrategyHistoryModal-modalName');

        return (
            <OKModal
                content={buildModelContent}
                isOpen={isModalOpen}
                onCloseCallback={onModalClose}
                descriptionAlignment="center"
                shouldCloseOnOverlayClick={false}
                title={title}
                titleAlignment="center"
            />
        );
    }
}

RAStrategyHistoryModal.propTypes = {
    getPortfolioHistory: PropTypes.func.isRequired,
    immAccountDetails: PropTypes.object.isRequired,
    immRAPortfolioDistribution: PropTypes.object.isRequired,
    immPortfolio: PropTypes.object,
    isModalOpen: PropTypes.bool.isRequired,
    onModalClose: PropTypes.func.isRequired,
    historyProfile: PropTypes.func.isRequired,
    portfolioId: PropTypes.string,
};

module.exports = RAStrategyHistoryModal;
